<div
  class="status-label"
  [ngClass]="{
    quoting: statusCode === statuses.Quoting,
    enrollment: statusCode === statuses.Enrollment,
    submitted: statusCode === statuses.Submitted,
    active: statusCode === statuses.Active,
    termed: statusCode === statuses.Termed
  }">
  <span>{{ statusLabel }}</span>
</div>
